import store from "./store";

const handleError = error => {
  console.log("handle errors");
  const errorStatus = error ? error.status : error;
  const errorMessage = prepareErrorMessage(errorStatus);
  store.dispatch("populateErrors", error.response.data.message);
};

// Catch any error
// as seen here https://www.youtube.com/watch?v=9YkUCxvaLEk
export const wrapRequest = fn => {
  console.log("wrunning wrap", fn);
  return (...params) => {
    console.log("in function");
    return fn(...params)
      .then(response => {
        console.log("is ookay", response);
        return response;
      })
      .catch(error => {
        console.log("handle error", error.response);
        handleError(error);
      });
  };
};

const prepareErrorMessage = status => {
  switch (status) {
    case 401:
      return "Unauthenticated.";
    case 422:
      return "Unprosomething entity";
    case 404:
      return "Resource not found";
    case 405:
      return "Read the manual";
    default:
      return "Error, please try again later";
  }
};
